import client from './axiosClient';
export const getUsers      = ()       => client.get('/users');
export const getUser       = id       => client.get(`/users/${id}`);
export const createUser    = dto      => client.post('/users', dto);
export const updateUser    = (id,dto) => client.put(`/users/${id}`, dto);
export const toggleStatus  = id       => client.patch(`/users/${id}/toggle-status`);
